module.exports = __webpack_public_path__ + "img/intervinientes.6a6027fe.png";